module.exports = __webpack_public_path__ + "img/camp_shirt_gk9.2796996b.svg";